import { render, staticRenderFns } from "./documentos-apoyos.vue?vue&type=template&id=2ecba7a0&"
import script from "./documentos-apoyos.component.ts?vue&type=script&lang=ts&"
export * from "./documentos-apoyos.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports